import { useState, useEffect } from 'react';

interface Responsive {
  isMobile: boolean;   // < 768px
  isTablet: boolean;   // 768–1024px
  isDesktop: boolean;  // > 1024px
  width: number;
}

export function useResponsive(): Responsive {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handler = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  return {
    isMobile: width < 768,
    isTablet: width >= 768 && width <= 1024,
    isDesktop: width > 1024,
    width,
  };
}
